'use strict';

module.exports = String.fromCharCode;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/chr.js
// module id = 88
// module chunks = 1